<template>
  <div class="card-price">
    <div class="price-per-month">
      <span class="currency">{{ currencySymbol }}</span>
      <span class="price-value">{{ prices.perMonth }}</span>
      <span class="per-month">{{ __('website.tariffs.mo') }}</span>
    </div>
    <div class="per-period">
      <span
      v-if="prices.withDiscount"
      class="crossed-out"
      >{{ currencySymbol }}{{ prices.fullPrice }}</span>
      <span class="price-with-discount">
        {{ currencySymbol }}{{ prices.withDiscount || prices.fullPrice }}
      </span>
      {{ perPeriodText }}
    </div>
  </div>
</template>

<script>
import { currencies } from '@/mainData';

export default {
  name: 'CardPrice',

  props: {
    months: {
      type: Number,
      default: 1,
    },

    prices: {
      type: Object,
      required: true,
    },

    currency: {
      type: String,
      default: '$',
    },
  },

  computed: {
    perPeriodText() {
      switch (this.months) {
        case 1:
          return this.__('website.tariffs.for_1mo');
        case 3:
          return this.__('website.tariffs.for_3mo');
        case 6:
          return this.__('website.tariffs.for_6mo');
        case 12:
          return this.__('website.tariffs.for_12mo');
        default:
          return this.__('website.tariffs.for_12mo').replace('12', this.months);
      }
    },

    currencySymbol() {
      return currencies[this.currency].symbol;
    }
  },
};
</script>

<style lang="sass" scoped>
.card-price
  margin: 0 0 16px
.price-per-month
  font-size: 34px
  line-height: 48px
  color: #fff
  margin: 0 0 4px
  .currency
    font-weight: 300
    margin: 0 4px 0 13px
  .price-value
    font-weight: 700
  .per-month
    font-size: 14px
    line-height: 21px
    margin-left: 3px

.per-period
  font-size: 16px
  line-height: 24px
  color: #BCC4D2
  .crossed-out
    color: #FFAF64
    display: inline-block
    position: relative
    margin-right: 5px
    &::after
      content: ''
      position: absolute
      left: -2px
      right: -1px
      top: 50%
      height: 0
      border-top: 1px solid #FFAF64
  .price-with-discount
    font-weight: 500
</style>